import { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import KogInputAmountControlled from "@/main/components/shared/inputText/inputAmountControlled";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";
import { HeaderSection, HeaderText } from "@/main/components/shared/styles";
import { Controls } from "@/main/services/constants/constantsControl";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

import { IPreQuoteForm, usePreQuoteContext } from "../context";
import { backendForFrontendGlass, checkPendingGlass } from "../utilsPrequote";
import * as S from "./styles";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";
import Warning from "@mui/icons-material/Warning";

function SectionGlass() {
	const CONTROL_GLASS_SECTION = useKogControlElementId(Controls.IdGlassSession);

	const { preQuoteData, isLoadingInfoOrder } = usePreQuoteContext();
	const { control, trigger } = useFormContext<IPreQuoteForm>();
	const { fields, append } = useFieldArray<IPreQuoteForm>({
		name: "glasses",
	});

	function loadGlassFields() {
		if (isNullUndefined(preQuoteData) || isNullUndefined(preQuoteData.preQuoteGlass)) return;
		const { glasses } = backendForFrontendGlass(preQuoteData);

		append(glasses);
	}

	useEffect(() => {
		if (!isLoadingInfoOrder && !isNullUndefined(preQuoteData)) {
			loadGlassFields();
		}
	}, [isLoadingInfoOrder, JSON.stringify(preQuoteData)]);

	useEffect(() => {
		if (fields.length > 0) {
			trigger("glasses");
		}
	}, [JSON.stringify(fields)]);

	const showGlassPending = !isNullUndefined(preQuoteData) && checkPendingGlass(preQuoteData);

	if (!showGlassPending || !CONTROL_GLASS_SECTION) return null;

	return (
		<S.Container>
			<HeaderSection>
				<HeaderText>{getTranslateByKey("information.glassInformation")}</HeaderText>
			</HeaderSection>
			<S.BodySection>
				{fields.map((field, index) => (
					<S.RowContainer key={field.id}>
						<RenderTooltipMessage
							withClick={!field.notes}
							tooltipMessage={!field.notes && field.partnumber ? field.partnumber : undefined}
						>
							<KogInputTextControlledNew
								name={`glasses.${index}.partnumber`}
								label={getTranslateByKey("information.PartNumbers")}
								control={control}
								disabled
								required
								id="id-prequote-txt-quoteFilterVehicle"
								InputProps={{
									endAdornment: field.notes && (
										<RenderTooltipMessage tooltipMessage={field.partnumber}>
											<Warning
												fontSize="small"
												style={{
													color: "#fab01c",
													cursor: "pointer",
													marginLeft: 10,
												}}
											/>
										</RenderTooltipMessage>
									),
								}}
							/>
						</RenderTooltipMessage>
						<KogInputTextControlledNew
							name={`glasses.${index}.code`}
							label={getTranslateByKey("information.code")}
							control={control}
							id="id-prequote-txt-quoteFilterVehicle"
							autoComplete="off"
							onChangeCustom={() => {}}
							required
						/>
						<KogInputAmountControlled
							required={false}
							typeInput={"filled"}
							id="id-prequote-txt-answeredPrice"
							name={`glasses.${index}.refPrice`}
							disabledMessage={false}
							customInputProps={{
								disabled: false,
							}}
							label={getTranslateByKey("information.refPrice")}
							control={control}
							hideValue={false}
							controllerProps={{}}
						/>
					</S.RowContainer>
				))}
			</S.BodySection>
		</S.Container>
	);
}

export default SectionGlass;
